import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const SET_UNKNOWN_ERROR = 'CADASTRAL_FIELDS :: SET_UNKNOWN_ERROR';

export type TSetUnknownErrorAction = IReduxAction<typeof SET_UNKNOWN_ERROR>;

export const setUnknownError = actionGenerator<typeof SET_UNKNOWN_ERROR>(SET_UNKNOWN_ERROR);
